import { render, staticRenderFns } from "./GlobalOrderModal.vue?vue&type=template&id=701a8d28&"
import script from "./GlobalOrderModal.vue?vue&type=script&lang=js&"
export * from "./GlobalOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalOrderModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports